export default import.meta.ROLLDOWN_FILE_URL_aSMIKoVjg9eBVhq93XNWlA